/**
 * This class provides the functions to manage game servers.
 */
class GameServerManager {

	/**
	 * The instance of this class.
	 */
	constructor() {

		this.REFRESH_INTERVAL = 2000;
		this.gameServerElements = $('[data-game-server-manager]');
		this.fetchInterval = window.setInterval(this.fetch, this.REFRESH_INTERVAL);
		this.pendingAction = {};
		this.pendingActionTimeout = 15000;

		this.fetch();

		$(document).on('click', '[data-game-server-manager-action]', (e) => { this.actionClick(e); });
	}

	/**
	 * Handles action button clicks.
	 *
	 * @param {Object} e The event object.
	 */
	actionClick = (e) => {

		e.preventDefault();

		const obj = $(e.target);
		const action = obj.data('game-server-manager-action');
		const parentObj = obj.parent().parent().parent();
		const gameServerType = obj.data('game-server-type');

		if(action !== 'start' && action !== 'stop' && action !== 'restart') {
			return;
		}

		window.clearInterval(this.fetchInterval);
		window.setTimeout(() => {
			this.pendingAction[gameServerType] = null;
		}, this.pendingActionTimeout);

		if(action === 'start') {
			this.pendingAction[gameServerType] = 'start';
			this.setActionStatusStarting(parentObj);
			Snackbar.success('<i class="fa fa-check-circle"></i> ' + tex('gameserver_manager.action.start_queued'));
		}
		else if(action === 'restart') {
			this.pendingAction[gameServerType] = 'restart';
			this.setActionStatusRestarting(parentObj);
			Snackbar.success('<i class="fa fa-check-circle"></i> ' + tex('gameserver_manager.action.restart_queued'));
		}
		else {
			this.pendingAction[gameServerType] = 'stop';
			this.setActionStatusStopping(parentObj);
			Snackbar.success('<i class="fa fa-check-circle"></i> ' + tex('gameserver_manager.action.stop_queued'));
		}

		$.ajax({
			method: 'POST',
			url: '/ajax/game-server-manager/set-action/',
			data: { csrf_token: CSRF_TOKEN, game_server_type: gameServerType, action: action },
			async: true,
			dataType: 'json',
		})
		.done(() => {
			window.setTimeout(() => {
				self.fetchInterval = window.setInterval(this.fetch, this.REFRESH_INTERVAL);
			}, 2000);
		});
	}

	/**
	 * Fetches the current server status.
	 */
	fetch = () => {

		const self = this;
		this.gameServerElements.each((k, v) => {

			const obj = $(v);
			const gameServerType = obj.data('game-server-type');

			$.ajax({
				method: 'POST',
				url: '/ajax/game-server-manager/get-status/',
				data: {
					csrf_token: CSRF_TOKEN,
					game_server_type: gameServerType
				},
				async: true,
				dataType: 'json',
				success: function (json) {

					if(self.pendingAction.hasOwnProperty(gameServerType) === false) {
						self.pendingAction[gameServerType] = null;
					}

					if(
						json.data.starting === true
						||
						json.data.restarting === true
						||
						json.data.stopping === true
						||
						json.data.running === true
					) {
						self.pendingAction[gameServerType] = null;
					}

					if(json.data.starting === true || self.pendingAction[gameServerType] === 'start') {
						self.setActionStatusStarting(obj);
					}
					else if(json.data.restarting === true || self.pendingAction[gameServerType] === 'restart') {
						self.setActionStatusRestarting(obj);
					}
					else if(json.data.stopping === true || self.pendingAction[gameServerType] === 'stop') {
						self.setActionStatusStopping(obj);
					}
					else if(json.data.running === true && self.pendingAction[gameServerType] === null) {
						self.setActionStatusRunning(obj, json.data);
					}
					else {
						self.setActionStatusStop(obj);
					}

					if(json.data.hasOwnProperty('status_text') === true && json.data.status_text !== null) {
						obj.find('[data-game-server-manager-status-text]').removeClass('d-none').text(json.data.status_text);
					}
					else {
						obj.find('[data-game-server-manager-status-text]').addClass('d-none');
					}

					if(json.data.hasOwnProperty('last_error') === true && json.data.last_error !== null) {
						obj.find('[data-game-server-manager-last-error]').removeClass('d-none').text(json.data.last_error);
					}
					else {
						obj.find('[data-game-server-manager-last-error]').addClass('d-none');
					}
				}
			});
		});
	}

	/**
	 * Sets the starting status for a server.
	 *
	 * @param {Object} obj The jQuery element.
	 */
	setActionStatusStarting = (obj) => {
		obj.find('[data-game-server-manager-status-starting]').removeClass('d-none');
		obj.find('[data-game-server-manager-status-stopping]').addClass('d-none');
		obj.find('[data-game-server-manager-status-started]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopped]').addClass('d-none');
		obj.find('[data-game-server-manager-status-loading]').addClass('d-none');

		obj.find('[data-game-server-manager-action="loading"]').removeClass('d-none');
		obj.find('[data-game-server-manager-action="start"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="restart"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="stop"]').addClass('d-none');
	}

	/**
	 * Sets the restarting status for a server.
	 *
	 * @param {Object} obj The jQuery element.
	 */
	setActionStatusRestarting = (obj) => {
		obj.find('[data-game-server-manager-status-restarting]').removeClass('d-none');
		obj.find('[data-game-server-manager-status-starting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopping]').addClass('d-none');
		obj.find('[data-game-server-manager-status-started]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopped]').addClass('d-none');
		obj.find('[data-game-server-manager-status-loading]').addClass('d-none');

		obj.find('[data-game-server-manager-action="loading"]').removeClass('d-none');
		obj.find('[data-game-server-manager-action="start"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="restart"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="stop"]').addClass('d-none');
	}

	/**
	 * Sets the stopping status for a server.
	 *
	 * @param {Object} obj The jQuery element.
	 */
	setActionStatusStopping = (obj) => {
		obj.find('[data-game-server-manager-status-stopping]').removeClass('d-none');
		obj.find('[data-game-server-manager-status-restarting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-starting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-started]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopped]').addClass('d-none');
		obj.find('[data-game-server-manager-status-loading]').addClass('d-none');

		obj.find('[data-game-server-manager-action="loading"]').removeClass('d-none');
		obj.find('[data-game-server-manager-action="start"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="restart"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="stop"]').addClass('d-none');
	}

	/**
	 * Sets the running status for a server.
	 *
	 * @param {Object} obj The jQuery element.
	 * @param {Object} resp The response data object.
	 */
	setActionStatusRunning = (obj, resp) => {

		if(resp.players_online !== undefined && resp.players_online !== false) {
			obj.find('[data-game-server-players-online]').html(`${resp.players_online.online} / ${resp.players_online.max}`);
		}
		else {
			obj.find('[data-game-server-players-online]').html('---');
		}

		if(resp.auto_stop_disabled === true) {
			obj.find('[data-game-server-manager-flag-disabled-auto-stop]').removeClass('d-none');
		}
		else {
			obj.find('[data-game-server-manager-flag-disabled-auto-stop]').addClass('d-none');
		}

		obj.find('[data-game-server-started-seconds]').html(resp.seconds_since_start);

		obj.find('[data-game-server-manager-status-started]').removeClass('d-none');
		obj.find('[data-game-server-manager-status-restarting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopped]').addClass('d-none');
		obj.find('[data-game-server-manager-status-loading]').addClass('d-none');
		obj.find('[data-game-server-manager-status-starting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopping]').addClass('d-none');

		obj.find('[data-game-server-manager-action="loading"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="start"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="restart"]').removeClass('d-none');
		obj.find('[data-game-server-manager-action="stop"]').removeClass('d-none');
	}

	/**
	 * Sets the stopped status for a server.
	 *
	 * @param {Object} obj The jQuery element.
	 */
	setActionStatusStop = (obj) => {
		obj.find('[data-game-server-manager-status-started]').addClass('d-none');
		obj.find('[data-game-server-manager-status-restarting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopped]').removeClass('d-none');
		obj.find('[data-game-server-manager-status-loading]').addClass('d-none');
		obj.find('[data-game-server-manager-status-starting]').addClass('d-none');
		obj.find('[data-game-server-manager-status-stopping]').addClass('d-none');

		obj.find('[data-game-server-manager-action="loading"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="restart"]').addClass('d-none');
		obj.find('[data-game-server-manager-action="start"]').removeClass('d-none');
		obj.find('[data-game-server-manager-action="stop"]').addClass('d-none');
	}
}
